import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { CustomCard } from "../../../components/Card/CustomCard";

import{ ConsulEstCuenta } from "../../../funciones/SolicitudesFunction";
import { ConsultVerificacionesInd } from '../../../funciones/AdministracionFunction';
import { BusquedaEstInd, Reintegro } from "../../../funciones/CobranzasFunction";
import { ConsultCuentaAdmin } from "../../../funciones/EstCuentaFunction";

import VerificacionPagoTable from "../../Administracion/EstadosCuentaContent/VerificacionPagoTable";
import EstIngresosTable from "./EstIngresosTable";

let detalleEst = "";
let CuentaPay = 0;
class Reintegros extends Component {
    state = {
        string: "",
        icon2: "",
        listEst: [],
        verificaciones: [],
        preloaderI:{
            icon: "",
            text: "Ingresa la Cédula, el nombre o el apellido del estudiante para buscar"
        },
        control: false,
        control2: false,
        boton1: {
            icon: "fa fa-money",
            text: "Reintegrar",
            disabled: false
        },
        monto: "",
        selectMetodos: { value: 'Transferencia', label: ' - Transferencia - ' },
        referencia: "",
        observaciones: "",
        cambio: "",
        totalCambio: 0,
    }

    componentDidMount = () => {
        detalleEst = "";
        CuentaPay = 0;

        this.setState({
            listEst:[],
            verificaciones: [],
        })
    }

    cambiaValor = (prop) => (e) => {
        this.setState({
            [prop]: (e.target.value).toUpperCase()
        })
    }

    cambiaValorDivisa = (prop) => (e) => {
        if (!isNaN(Number(e.target.value)) === false) return null

        this.setState({
            [prop]: e.target.value
        }, () => {
            let tmp = this.state.monto * this.state.cambio
            this.setState({
                totalCambio: tmp
            })
        })
    }

    valorMetodos = (selectMetodos) => {
        this.setState({selectMetodos})
    }

    busquedaEst = () => (e) => {
        if (e.which === 13){
            detalleEst = "";
            CuentaPay = 0;
            this.setState ({
                icon2: "fa fa-spinner fa-spin",
                preloaderI:{
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando estudiantes, espera"
                },
                listEst: [],
                verificaciones: [],
            }, () => {
                BusquedaEstInd (this.state.string, (resp) => {
                    let prel = { icon: "", text: "" };
                    if (resp.length === 0) prel = { icon: "", text: "No existen coincidencias con la búsqueda seleccionada" };

                    this.setState({
                        listEst: resp,
                        icon2: "",
                        preloaderI: prel,
                    })
                })
            })
        }
    }

    reinteg = () => {
        let { monto, boton1, selectMetodos, referencia, cambio, observaciones } = this.state

        if (boton1.disabled === true) return null;

        switch (selectMetodos.value){
            case "Transferencia":
                if (referencia === "") {
                    toast.error("Debes indicar el numero de la referencia",{autoClose: 4000});
                    return null;
                }
            break
            case "Divisa":
                if (cambio === "") {
                    toast.error("Debes indicar valor del cambio por dólar en Bs",{autoClose: 4000});
                    return null;
                }
            break
        }

        if (monto === "") {
            toast.error("Debes asignar el monto del reintegro",{autoClose: 4000});
            return null;
        }
        if (!isNaN(Number(monto)) === false) {
            toast.error("El monto debe contener solo números",{autoClose: 4000});
            return null;
        }

        this.setState({
            boton1: {
                icon: "fa fa-spinner fa-spin",
                text: "Espera",
                disabled: true
            }
        }, () => {
            let campos = { monto, selectMetodos, referencia, observaciones, cambio }

            Reintegro (campos, detalleEst[1].id, (resp) => {
                if (resp.status === "NOk"){
                    toast.error(resp.mess, {autoClose: 6000});
                    this.setState({
                        boton1: {
                            icon: "fa fa-money",
                            text: "Reintegrar",
                            disabled: false
                        },
                        monto: "",
                    })
                }else if (resp.status === "Ok"){
                    let data1 = detalleEst[1]
                    ConsultCuentaAdmin (detalleEst[1].id, (resp)=> {
                        detalleEst = [resp, data1]
                        toast.info("Se ha realizado correctamente el asiento de reintegro al estudiante",{autoClose: 4000});
                        this.setState({
                            boton1: {
                                icon: "fa fa-money",
                                text: "Reintegrar",
                                disabled: false
                            },
                            monto: "",
                            selectMetodos: { value: 'Transferencia', label: ' - Transferencia - ' },
                            referencia: "",
                            observaciones: "",
                            cambio: "",
                            totalCambio: 0,
                        }) 
                    })
                }else{
                    toast.error(resp.mess, {autoClose: 4000});
                    this.setState({
                        boton1: {
                            icon: "fa fa-money",
                            text: "Reintegrar",
                            disabled: false
                        },
                        monto: "",
                    }) 
                }
            })
        })
    }

    contenido = () => {
        let { string, icon2, listEst, preloaderI, boton1, monto, selectMetodos, referencia, observaciones, cambio,
            totalCambio, verificaciones } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        const metodos = [
            { value: 'Transferencia', label: ' - Transferencia - ' },
            { value: 'Efectivo', label: ' - Efectivo - ' },
            { value: 'Divisa', label: ' - Divisa - ' }
        ]

        let tablaEst = () => {
            if (listEst.length === 0) return (<div align="center" className="text-danger"><i className={preloaderI.icon}></i> {preloaderI.text}</div>)

            return (
                <div className="table-responsive" style={{overflowY: "auto", maxHeight: "25vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="45%" style={styles}><strong>Estudiante</strong></td>
                                <td width="35%" align="center" style={styles}><strong>Carrera</strong></td>
                                <td width="20%" align="center" style={styles}><strong>Estado</strong></td>
                                <td width="200px" align="center" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {listEst.map (option => (
                                <EstIngresosTable key={option.id} datos={option}
                                    Detalles={(datos) => {

                                        ConsulEstCuenta (datos[1].id, (resp) => {
                                            CuentaPay = resp[0];
                                        })

                                        ConsultVerificacionesInd (datos[1].id, (resp)=> {
                                            this.setState({verificaciones: resp,})
                                        })

                                        detalleEst = datos;
                                        this.setState({
                                            control: !this.state.control,
                                            boton1: {
                                                icon: "fa fa-money",
                                                text: "Reintegrar",
                                                disabled: false
                                            },
                                            monto: "",
                                        })
                                    }}
                                />
                            ))}
                        </tbody>
                    </Table>
                </div>
            )
        }
    
        let contentEstado = () => {
            if (detalleEst[0].length === 0) return (
                <tr>
                    <td colSpan={7} align="center">No existen asientos disponibles</td>
                </tr>
            )

            let bs = (monto) => {
                let bs = `${monto} Bs.`;
                if (monto === "" || monto === null) bs = "";
                return bs;
            }

            let icono = (mess, status) => {
                let icono = <i className="fa fa-check-circle text-success"></i>;
                if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                return icono;
            }

            let status = (mess, status) => {
                let styles = {color:"#000"}
                if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                return styles;
            }

            let aviso = (mess, status) => {
                let aviso = "";
                if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                return aviso;
            }

            return (
                detalleEst[0].map(option => (
                    <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                        <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                        <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                        <td align="center" style={styles}>{bs(option.debe)}</td>
                        <td align="center" style={styles}>{bs(option.haber)}</td>
                        <td align="center" style={styles}>{option.saldo} Bs.</td>
                        <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                    </tr>
                ))
            )
        }

        let contentPago = () => {
            switch (selectMetodos.value){
                case "Transferencia": return (
                    <Row>
                        <Col md={6}>
                            <input type="text" onChange={this.cambiaValor("monto")} value={monto} className="form-control" placeholder="Monto del reintegro en Bs."/>
                            <div className="text-muted" style={{fontSize: 10}}>Monto</div>
                        </Col>
                        <Col md={6}>
                            <input type="text" onChange={this.cambiaValor("referencia")} value={referencia} className="form-control" placeholder="Nro de la transacción."/>
                            <div className="text-muted" style={{fontSize: 10}}>Referencia</div>
                        </Col>
                    </Row>
                )
                case "Efectivo": return (
                    <Row>
                        <Col md={12}>
                            <input type="text" onChange={this.cambiaValor("monto")} value={monto} className="form-control" placeholder="Monto del reintegro en Bs."/>
                            <div className="text-muted" style={{fontSize: 10}}>Monto</div>
                        </Col>
                    </Row>
                )
                case "Divisa": return (
                    <Row>
                        <Col md={6}>
                            <input type="text" onChange={this.cambiaValorDivisa("monto")} value={monto} className="form-control" placeholder="Monto del reintegro en Bs."/>
                            <div className="text-muted" style={{fontSize: 10}}>Monto</div>
                        </Col>
                        <Col md={6}>
                            <input type="text" onChange={this.cambiaValorDivisa("cambio")} value={cambio} className="form-control" placeholder="Indica el monto."/>
                            <div className="text-muted" style={{fontSize: 10}}>Valor del cambio</div>
                        </Col>
                        <Col md={12}>Equivalente en Bs del reintrego: {totalCambio}</Col>
                    </Row>
                )
            }
        }

        let pagos = () => (
            verificaciones.map(option => (
                <VerificacionPagoTable key={option.id} datos={option} updList = {() => {
                    let data1 = detalleEst[1]
                    ConsulEstCuenta (detalleEst[1].id, (resp) => {
                        CuentaPay = resp[0];
                    })

                    ConsultVerificacionesInd (detalleEst[1].id, (resp)=> {
                        this.setState({verificaciones: resp,})
                    })
                    
                    ConsultCuentaAdmin (detalleEst[1].id, (resp)=> {
                        detalleEst = [resp, data1]
                        this.setState({
                            control2: !this.state.control
                        }) 
                    })
                }}/>
            ))
        )

        let pays = () => {
            if (CuentaPay === 0) return null;

            return(
                <div className="custom-alert-info custom-mt-10" style={{padding: 2}}>
                    <div>Verificación de Pago del Estudiante</div>
                    <div className="table-responsive" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "30vh", overflowX:"hidden"}}>
                        <Table striped hover bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="40%" style={styles}><strong>Estudiante</strong></td>
                                    <td width="60%%" style={styles}><strong>Detalles del Pago</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {pagos()}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )
        }

        let detalles = () => {
            if (listEst.length === 0) return null;
            if (detalleEst === "") return (<div className="text-danger custom-mt-10" align="center">Selecciona un Estudiante para revisar su Estado de Cuenta</div>)

            return (
                <React.Fragment>
                    <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                        <Row>
                            <Col md={12}>
                                <div style={{marginTop: 10}}>Estado de Cuenta de <strong>{detalleEst[1].Estudiante}</strong></div>
                            </Col>
                        </Row>
                    </div>
                    <Row className="custom-mt-10">
                        <Col md={6}><span className="text-danger">Carrera:</span> <strong>{detalleEst[1].Carrera}</strong></Col>
                        <Col md={6} align="right"><span className="text-danger">Deuda:</span> <strong>{detalleEst[1].Deuda}</strong></Col>
                    </Row>
                    <div className="table-responsive" style={{overflowY: "auto", maxHeight:"45vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                        <Table striped hover bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="10%" align="center" style={styles}><strong>N°</strong></td>
                                    <td width="10%" align="center" style={styles}><strong>Fecha</strong></td>
                                    <td width="40%" style={styles}><strong>Descripción</strong></td>
                                    <td width="12%" align="center" style={styles}><strong>Facturado</strong></td>
                                    <td width="12%" align="center" style={styles}><strong>Pagado</strong></td>
                                    <td width="16%" align="center" style={styles}><strong>Balance</strong></td>
                                    <td width="30px" align="center" style={styles}></td>
                                </tr>
                                {contentEstado()}
                            </tbody>
                        </Table>
                    </div>
                    {pays()}
                    <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>
                        <Row>
                            <Col md={12}>Opciones de Reintegro</Col>
                            <Col md={6}>
                                <Select
                                    isSearchable ={true}
                                    value={selectMetodos}
                                    onChange={this.valorMetodos}
                                    options={metodos}
                                />
                                <div className="text-muted" style={{fontSize: 10}}>Selecciona un Método de Pago</div>
                            </Col>
                            <Col md={6}>
                                <input type="text" onChange={this.cambiaValor("observaciones")} value={observaciones} className="form-control" placeholder="Ej.: Transferencia al Banco de Venezuela"/>
                                <div className="text-muted" style={{fontSize: 10}}>Observaciones</div>
                            </Col>
                            <Col md={8} className="custom-mt-10">
                                {contentPago()}
                            </Col>
                            <Col md={4} align="right" className="custom-mt-10">
                                <button className="btn btn-relleno-primary" onClick={this.reinteg} style={{borderWidth:1}} title={`Reintegrar monto a ${detalleEst[1].Estudiante}`}><i className={boton1.icon}></i> {boton1.text}</button>
                            </Col>
                        </Row>
                    </div>
                </React.Fragment>
            )
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info">
                    Búsqueda de Estudiantes <i className={icon2}></i>
                    <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={string} onChange={this.cambiaValor("string")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                </div>
                <div className="custom-mt-10">{tablaEst()}</div>
                <div className="custom-mt-10">{detalles()}</div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                Este módulo permite registrar el reintegro de pagos al estudiante. para esto primero debes ingresar la cédula, el nombre o el apellido del alumno y presionar la tecla ENTER
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Al ingresar uno de estos datos te aparecerá una tabla con los resultados indicando: El estudiante, La carrera, su estado (<i className="fa fa-check-circle text-success"></i> SOLVENTE o <i className="fa fa-times-circle text-danger"></i> EN MORA) y el botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-money"></i> Cuenta</button>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Una vez seleccinado el estudiante presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-money"></i> Cuenta</button> para ver su estado de cuenta y las opciones de reintegro disponibles
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Opciones del Estado de Cuenta y Reintegro</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                En el estado de cuenta puedes ver los asientos del estudiante asi como también el estatus de cada transacción:
            </Col>
            
            <Col md={2}className="custom-mt-10"><i className="fa fa-check-circle text-success"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Indica que la transacción esta aprobada
            </Col>
            <Col md={2} className="custom-mt-10"><i className="fa fa-exclamation-triangle text-warning"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Indica que la transacción está pendiente por aprobación
            </Col>
            <Col md={2} className="custom-mt-10"><i className="fa fa-times-circle text-danger"></i></Col>
            <Col md={10} align="justify" className="custom-mt-10">
                Este ícono representa un error en la transacción o que la transacción es inválida, en este caso deberás ponerte en contacto con administración
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                <strong>En caso que el estudiante posea un pago pendiente de aprobacion: </strong> puedes aprobar o no (segpun sea el caso) la transacción del estudiante
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                <strong>Importante: no puedes reintegrar dinero a estudiantes que tengan pendiente una aprobación de pago anterior</strong>
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong>Opciones de Reintegro</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Primero selecciona el método de pago. luego completa los campos según sea el caso y presiona el botón <button className="btn btn-relleno-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-money"></i> Reintegrar</button>
            </Col>
        </Row>
    )

    render() {
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Reintegros</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default Reintegros;


// WEBPACK FOOTER //
// ./src/views/Administracion/IngresosContent/Reintegros.jsx